import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as RFSActionType from '../constants';
import { Row, Table, Col } from 'react-bootstrap';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import Moment from 'moment';
import { printEOF } from '../../helper/unit-helper';
import SignatureCanvas from 'react-signature-canvas';
import * as CommonActionType from 'Common/constants';
import { Link } from 'react-router-dom';
import Datetime from 'react-datetime';
import { AppSettings } from '../../constants';
import { Popup } from 'components/Popup/popup';
import TagsInput from '../../components/tag-input';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import * as WorkOrderActionType from '../../Work-Orders/constants';

const popupStyle = {
  width: 300,
  height: 200,
  top: -290,
  left: 600
};

const saveAndProcessStyle = {
  width: 330,
  height: 150,
  top: -260,
  left: 430
};

const saveAndSendEmailStyle = {
  width: 330,
  height: 150,
  top: -260,
  left: '33vw'
};

const TAGS_LIST = [9, 13, 188];

class EocListItems extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    EOCProfile: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    RFSEndpoint: PropTypes.object,
    HomeownerPrimaryEmail: PropTypes.string
  };
  constructor(props) {
    super(props);
    let RFSID = null;

    if (props.match.params.RFSID) {
      RFSID = props.match.params.RFSID;
    }

    this.state = {
      refNo: RFSID,
      commonInformation: null,
      orientationCheckList: null,
      functionBtnSignaturePad: true,
      buyer1Date:null,
      buyer2Date: null,
      csrDate: null,
      checkboxes: {},
      error: {
        buyer1Date: null,
        buyer2Date: null,
        csrDate: null
      },
      buyer1SignatureUrl: null,
      buyer2SignatureUrl: null,
      csrSignatureUrl: null,
      signaturesChecklist: [],
      signatureUpload: [],
      buyer1Signature: true,
      buyer2Signature: true,
      csrSignature: true,
      rfsEndpoint: null,
      removeSignature1: false,
      removeSignature2: false,
      removeCsr: false,
      isDisplayEmailPopUp: false,
      recipientEmail: this.props.HomeownerPrimaryEmail ? [this.props.HomeownerPrimaryEmail] : [],
      inputProps: { placeholder: 'Type email address' },
      openConfirmSavePopup: false,
      unSavedChange: false,
      approvalChecklist: null,
      onSaveAndProceed: false,
      suggestions:[]
    };
  }

  componentDidMount() {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.fetchRFS();
    } else {
      this.fetchEOC();
      this.fetchHomeOwnerEmail();
    }


    //click out to close send email pop up
    // const self = this;

    // window.addEventListener('click', e => {
    //   console.log(e.target,'cac');
    //   if (
    //     document.getElementById('reopen-popup') &&
    //       document.getElementById('reopen-popup').contains(e.target)
    //   ) {
    //     // Clicked in box
    //   } else if (this.state.isDisplayEmailPopUp) {
    //     this.setState({
    //       isDisplayEmailPopUp: false
    //     });
    //   }
    // });

  }

  componentWillReceiveProps(nextProps) {
    //map data to state checkboxes (1)
    if (nextProps.EOCProfile !== this.props.EOCProfile) {
      const updatedOrientationCheckList  = nextProps.EOCProfile.orientationCheckList;
      this.setState({
        commonInformation: nextProps.EOCProfile.commonInformation,
        orientationCheckList: updatedOrientationCheckList,
        buyer1SignatureUrl : updatedOrientationCheckList.buyerSignature1Url,
        buyer1Date: updatedOrientationCheckList.buyer1SignedDate && Moment(updatedOrientationCheckList.buyer1SignedDate).format('MM/DD/YYYY'),
        buyer2Signature : updatedOrientationCheckList.buyerSignature2Url,
        buyer2Date: updatedOrientationCheckList.buyer2SignedDate && Moment(updatedOrientationCheckList.buyer2SignedDate).format('MM/DD/YYYY'),
        csrSignatureUrl : updatedOrientationCheckList.csrSignatureUrl,
        csrDate : updatedOrientationCheckList.csrSignedDate && Moment(updatedOrientationCheckList.csrSignedDate).format('MM/DD/YYYY'),
      });
      if (
        nextProps.EOCProfile &&
        nextProps.EOCProfile.orientationCheckList &&
        nextProps.EOCProfile.orientationCheckList.sections
      ) {
        const { sections, buyer1SignedDate,buyer2SignedDate,csrSignedDate} = nextProps.EOCProfile.orientationCheckList;
        let { checkboxes } = this.state;
        sections.map(sec => {
          const { checkLists } = sec;
          checkLists.map(item => {
            checkboxes[item.id] = {
              approval: item.approval,
              checked: item.approval,
            
            };
          });
        });
      }
    }

    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (nextProps.RFSEndpoint !== this.props.RFSEndpoint) {
        this.setState(
          {
            rfsEndpoint: nextProps.RFSEndpoint
          },
          () => this.fetchEOCHomeowner()
        );
      }
    }

    if (nextProps.HomeownerPrimaryEmail !== this.props.HomeownerPrimaryEmail) {
      this.setState({
        recipientEmail: [nextProps.HomeownerPrimaryEmail]
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.buyer2SignatureUrl !== nextState.buyer2SignatureUrl || this.state.buyer1SignatureUrl !== nextState.buyer1SignatureUrl || this.state.approvalChecklist !== nextState.approvalChecklist || this.state.csrSignatureUrl !== nextState.csrSignatureUrl || this.state.buyer1Date !== nextState.buyer1Date || this.state.buyer2Date !== nextState.buyer2Date || this.state.csrDate !== nextState.csrDate) {
      this.setState({
        unSavedChange: true
      });
    }

  }

  onChecked = (e, value, data) => {
    let { checkboxes } = this.state;

    //map data to state checkboxes (2)
    checkboxes[value].checked = data.checked;
    const approvalChecklist = Object.entries(checkboxes)
      .filter(([key, el]) => el.approval !== el.checked)
      .map(el => ({
        id: el[0],
        approval: el[1].checked
      }));
    this.setState({
      checkboxes: checkboxes,
      approvalChecklist: approvalChecklist
    });

  };

  onSendEOCEmail = () => {
    const eocUrl = `${AppSettings.CURRENT_SITE_URI}${this.props.match.url}`;
    if (this.state.unSavedChange) {
      this.setState({
        openConfirmSavePopup: true,
        isDisplayEmailPopUp: false,
        confirmSendEmailPopup: true
      });
    } else {
      this.setState({
        isDisplayEmailPopUp: false
      }, () => {
        this.props.dispatch({
          type: RFSActionType.SEND_EOC_TEMPLATE_EMAIL_ASYNC,
          params: {
            refNo: this.state.refNo,
            Emails: this.state.recipientEmail,
            rfsUrl: eocUrl
          }
        });
      });
    }
  }

  onSaveAndSaveToLotDocument = () => {
    this.setState({
      openConfirmSavePopup: false,
      onSaveAndProceed: true,
      onSaveAndSendEmail: false
    }, () => this.onSubmit());

  }

  onSaveAndSendEmail = () => {
    this.setState({
      openConfirmSavePopup: false,
      onSaveAndSendEmail: true,
      onSaveAndProceed: false
    }, () => this.onSubmit());
  }

  fetchRFS = () => {
    this.props.dispatch({
      type: RFSActionType.GET_GLOBAL_ENDPOINT_RFS_ASYNC,
      params: this.state.refNo
    });
  };

  fetchEOCHomeowner = () => {
    this.props.dispatch({
      type: RFSActionType.EOC_TEMPLATE_HOMEOWNER_ASYNC,
      params: {
        endpoint: this.state.rfsEndpoint.renderEocEndpoint,
        headers: {
          key: this.state.rfsEndpoint.headerKey,
          value: this.state.rfsEndpoint.securityToken
        }
      }
    });
  };

  fetchEOC = () => {
    this.props.dispatch({
      type: RFSActionType.GET_EOC_DETAIL_ASYNC,
      params: {
        refNo: this.state.refNo
      },
      callback:(data)=>{
        let {orientationCheckList} =data;
    if (orientationCheckList.buyer2SignatureUrl ||orientationCheckList.buyer1SignatureUrl || orientationCheckList.approvalChecklist || orientationCheckList.csrSignatureUrl || orientationCheckList.buyer1Date || orientationCheckList.buyer2Date || orientationCheckList.csrDate) {
      this.setState({
        unSavedChange: true
      });
    }
      }
    });
  };

  fetchHomeOwnerEmail = () => {
    this.props.dispatch({
      type: RFSActionType.GET_EMAIL_PRIMARY_HOMEOWNER_ASYNC,
      params: {
        refNo: this.state.refNo
      }
    });
  }

  onSaveLotDocument = () => {

    if (this.state.unSavedChange) {
      this.setState({
        openConfirmSavePopup: true,
        confirmSendEmailPopup: false
      });
    } else {
      this.props.dispatch({
        type: RFSActionType.SAVE_EOC_TEMPLATE_TO_LOT_DOCUMENT_ASYNC,
        params: {
          refNo: this.state.refNo
        }
      });
    }

  }

  onSendEmailPrimaryOwner = () => {
    this.onFetchAllEmails();

    this.setState({
      isDisplayEmailPopUp: true
    });
  }

  
  onFetchAllEmails = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_ALL_USER_EMAILS,
      params: {  },
      callback: (res, isSuccess) => {
        this.setState({
          ...this.state,
          suggestions: res
        });
      }
    });
  };


  onCloseEmailPopup = () => {
    this.setState({
      isDisplayEmailPopUp: false
    });
  }

  onPrintEOCTemplate = () => {
    this.props.dispatch({
      type: RFSActionType.PRINT_EOC_TEMPLATE_ASYNC,
      params: {
        refNo: this.state.refNo
      },
      callback: (status, content) => {
        if (status) {
          printEOF(content);
        }
      }
    });
  };

  onPrintEOCTemplateAndSaveEOC = () => {
    const { approvalChecklist, orientationCheckList } = this.state;

    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.EOC_SUBMIT_TEMPLATE_HOMEOWNER_ASYNC,
        params: {
          endpoint: this.state.rfsEndpoint.submitEocEndpoint,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          },
          data: {
            eocId: this.state.orientationCheckList.id,
            refNo: this.state.refNo,
            checkItems: approvalChecklist,
            signatureBuyer1:
            this.state.removeSignature1 ? null : (this.state.buyer1SignatureUrl ||
              orientationCheckList.buyerSignature1Url),
            signatureBuyerDate1:
              this.state.buyer1Date || orientationCheckList.buyer1SignedDate,
            signatureBuyer2:
            this.state.removeSignature2 ? null : (this.state.buyer2SignatureUrl ||
              orientationCheckList.buyerSignature2Url),
            signatureBuyerDate2:
              this.state.buyer2Date || orientationCheckList.buyer2SignedDate,
            signatureCsr: this.state.removeCsr ? null : (this.state.csrSignatureUrl ||
              orientationCheckList.csrSignatureUrl),
            signatureCsrDate:
              this.state.csrDate || orientationCheckList.csrSignedDate
          }
        },
        callback: () => {
          this.renderEOCAfterSubmit();
        }
      });
    } else {
      this.props.dispatch({
        type: RFSActionType.SUBMIT_EOC_LIST_ASYNC,
        params: {
          data: {
            eocId: this.state.orientationCheckList.id,
            refNo: this.state.refNo,
            checkItems: approvalChecklist,
            signatureBuyer1: this.state.removeSignature1 ? null : (this.state.buyer1SignatureUrl ||
            orientationCheckList.buyerSignature1Url),
            signatureBuyerDate1:
                this.state.buyer1Date || orientationCheckList.buyer1SignedDate,
            signatureBuyer2:
            this.state.removeSignature2 ? null : (this.state.buyer2SignatureUrl ||
            orientationCheckList.buyerSignature2Url),
            signatureBuyerDate2:
                this.state.buyer2Date || orientationCheckList.buyer2SignedDate,
            signatureCsr:
            this.state.removeCsr ? null : (this.state.csrSignatureUrl ||
            orientationCheckList.csrSignatureUrl),
            signatureCsrDate:
                this.state.csrDate || orientationCheckList.csrSignedDate,
          },
        },
        isPrint: true,
        callback: () => {
          this.setState({
            submitSuccess: true
          }, () => {
            this.renderEOCAfterSubmit();
            if (this.state.submitSuccess) {
              setTimeout(() => {
                this.props.dispatch({
                  type: RFSActionType.PRINT_EOC_TEMPLATE_ASYNC,
                  params: {
                    refNo: this.state.refNo
                  },
                  callback: (status, content) => {
                    if (status) {
                      print(content);
                    }
                  }
                });
              }, 2000);
            }
          });
        }
      });
    }
  }

  onCancel = () => {
    this.props.history.push(`/request-for-services/${this.state.refNo}`);
  };

  onSubmit = () => {
    const { approvalChecklist } = this.state;
    this.submitAllData(approvalChecklist);
  };

  submitAllData = approvalChecklist => {
    const { orientationCheckList } = this.state;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.EOC_SUBMIT_TEMPLATE_HOMEOWNER_ASYNC,
        params: {
          endpoint: this.state.rfsEndpoint.submitEocEndpoint,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          },
          data: {
            eocId: this.state.orientationCheckList.id,
            refNo: this.state.refNo,
            checkItems: approvalChecklist,
            signatureBuyer1:
            this.state.removeSignature1 ? null : (this.state.buyer1SignatureUrl ||
              orientationCheckList.buyerSignature1Url),
            signatureBuyerDate1:
              this.state.buyer1Date || formatTimezoneDateTime(orientationCheckList.buyer1SignedDate, false),
            signatureBuyer2:
            this.state.removeSignature2 ? null : (this.state.buyer2SignatureUrl ||
              orientationCheckList.buyerSignature2Url),
            signatureBuyerDate2:
              this.state.buyer2Date || formatTimezoneDateTime(orientationCheckList.buyer2SignedDate, false),
            signatureCsr: this.state.removeCsr ? null : (this.state.csrSignatureUrl ||
              orientationCheckList.csrSignatureUrl),
            signatureCsrDate:
              this.state.csrDate || formatTimezoneDateTime(orientationCheckList.csrSignedDate, false)
          }
        },
        callback: () => {
          this.renderEOCAfterSubmit();
        }
      });
    } else {
      this.props.dispatch({
        type: RFSActionType.SUBMIT_EOC_LIST_ASYNC,
        params: {
          data: {
            eocId: this.state.orientationCheckList.id,
            refNo: this.state.refNo,
            checkItems: approvalChecklist,
            signatureBuyer1: this.state.removeSignature1 ? null : (this.state.buyer1SignatureUrl ||
            orientationCheckList.buyerSignature1Url),
            signatureBuyerDate1:
            this.state.buyer1Date || orientationCheckList.buyer1SignedDate,
            signatureBuyer2:
            this.state.removeSignature2 ? null : (this.state.buyer2SignatureUrl ||
            orientationCheckList.buyerSignature2Url),
            signatureBuyerDate2:
            this.state.buyer2Date|| orientationCheckList.buyer2SignedDate,
            signatureCsr:
            this.state.removeCsr ? null : (this.state.csrSignatureUrl ||
            orientationCheckList.csrSignatureUrl),
            signatureCsrDate:
            this.state.csrDate|| orientationCheckList.csrSignedDate
          }
        },
        isPrint:false,
        callback: () => {
          if (this.state.onSaveAndProceed) {
            this.props.dispatch({
              type: RFSActionType.SAVE_EOC_TEMPLATE_TO_LOT_DOCUMENT_ASYNC,
              params: {
                refNo: this.state.refNo
              }, callback: () => {
                this.setState({
                  unSavedChange: false,
                  onSaveAndProceed: false
                });
              }
            });
            this.renderEOCAfterSubmit();
          }
          if (this.state.onSaveAndSendEmail) {
            const eocUrl = `${AppSettings.CURRENT_SITE_URI}${this.props.match.url}`;
            this.props.dispatch({
              type: RFSActionType.SEND_EOC_TEMPLATE_EMAIL_ASYNC,
              params: {
                refNo: this.state.refNo,
                Emails: this.state.recipientEmail,
                rfsUrl: eocUrl
              }, callback: () => {
                this.setState({
                  unSavedChange: false,
                  onSaveAndSendEmail: false
                });
              }
            });
            this.renderEOCAfterSubmit();
          }
          this.renderEOCAfterSubmit();
        }
      });
    }
  };

  uploadCsrSignatureS3 = () => {
    const { refNo } = this.state;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.HOMEOWNER_RFS_SETUP_AWS_ASYNC,
        params: {
          builderHost: this.state.rfsEndpoint.builderHost,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          },
          param: { resourcePath: `/request-for-services/${refNo}/signatures` }
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.csrSignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getCsrSignatureS3(callbackData);
              }
            }
          });
        }
      });
    } else {
      this.props.dispatch({
        type: RFSActionType.SETUP_RFS_UPLOAD_SIGNATURE_S3,
        params: {
          resourcePath: `/request-for-services/${refNo}/signatures`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.csrSignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getCsrSignatureS3(callbackData);
              }
            }
          });
        }
      });
    }
  };

  onSaveCsrSignature = () => {
    this.setState({
      csrSignatureUrl: this.csrSignature
        .getTrimmedCanvas()
        .toDataURL('image/png'),
      removeCsr: false
    }, () => this.uploadCsrSignatureS3());
  };

  uploadBuyerSignature1ToS3 = () => {
    const { refNo } = this.state;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.HOMEOWNER_RFS_SETUP_AWS_ASYNC,
        params: {
          builderHost: this.state.rfsEndpoint.builderHost,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          },
          param: { resourcePath: `/request-for-services/${refNo}/signatures` }
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.buyer1SignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getBuyer1SignatureS3(callbackData);
              }
            }
          });
        }
      });
    } else {
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `/request-for-services/${refNo}/signatures`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.buyer1SignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getBuyer1SignatureS3(callbackData);
              }
            }
          });
        }
      });
    }
  }

  onSaveBuyerSignature1 = () => {
    this.setState({
      buyer1SignatureUrl: this.buyerSignature1
        .getTrimmedCanvas()
        .toDataURL('image/png'),
      removeSignature1: false
    }, () => this.uploadBuyerSignature1ToS3());
  };

  onUploadBuyerSignature2ToS3 = () => {
    const { refNo } = this.state;
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.HOMEOWNER_RFS_SETUP_AWS_ASYNC,
        params: {
          builderHost: this.state.rfsEndpoint.builderHost,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          },
          param: { resourcePath: `/request-for-services/${refNo}/signatures` }
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.buyer2SignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getBuyer2SignatureS3(callbackData);
              }
            }
          });
        }
      });
    } else {
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `/request-for-services/${refNo}/signatures`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo,
              data: this.state.buyer2SignatureUrl,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                this.getBuyer2SignatureS3(callbackData);
              }
            }
          });
        }
      });
    }
  }

  onSaveBuyerSignature2 = () => {
    this.setState({
      buyer2SignatureUrl: this.buyerSignature2
        .getTrimmedCanvas()
        .toDataURL('image/png'),
      removeSignature2: false
    }, () => this.onUploadBuyerSignature2ToS3());
  };

  getCsrSignatureS3 = callbackData => {
    this.setState({
      csrSignatureUrl: callbackData.data.Location,
    });
  };

  getBuyer1SignatureS3 = callbackData => {
    this.setState({
      buyer1SignatureUrl: callbackData.data.Location,
    });
  };

  getBuyer2SignatureS3 = callbackData => {
    this.setState({
      buyer2SignatureUrl: callbackData.data.Location,
    });
  };

  onChangeDate = (type, value) => {
    if (value) {
      if (Moment(value, 'MM/DD/YYYY', true).isValid()) {
        this.setState({
          [type]: value,
          error: {...this.state.error, [type]: null}
        });
      } else if (Moment(value, 'DD/MM/YYYY', true).isValid()) {
        let convertDate = (Moment(Moment(value, 'DD/MM/YYYY')).format('MM/DD/YYYY'));
        this.setState({
          [type]: convertDate,
          error: {...this.state.error, [type]: null}
        });
      } else if (Moment(value, 'YYYY/DD/MM', true).isValid()) {
        let convertDate = (Moment(Moment(value, 'YYYY/DD/MM')).format('MM/DD/YYYY'));
        this.setState({
          [type]: convertDate,
          error: {...this.state.error, [type]: null}
        });
      } else if (Moment(value, 'YYYY/MM/DD', true).isValid()) {
        let convertDate = (Moment(Moment(value, 'YYYY/MM/DD')).format('MM/DD/YYYY'));
        this.setState({
          [type]: convertDate,
          error: {...this.state.error, [type]: null}
        });
      } else {
        let convertDate = (Moment(Moment(value, 'YYYY/MM/DD')).format('MM/DD/YYYY'))
          this.setState({
          value:convertDate,
          error: {...this.state.error, [type]: null}
        });
      }
    } else {
      this.setState({
        [type]: value,
        error: {...this.state.error, [type]: null}
      });
    }
  };

  handleChange(tags) {
    let tagsValid = [];

    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    tags.map(tag => {
      if (emailPattern.test(tag)) {
        tagsValid.push(tag);
      }
    });

    // console.log(tagsValid, 'tagsValid');

    this.setState({
      recipientEmail: tagsValid
    });

    // $('.btn-submit').prop('disabled', this.validatorTradeAndCompanyEmail());
  }

  disabledSendEmail = () => {

    if (this.state.recipientEmail.length === 0) {
      return true;
    }

    return false;
  }

  onEditBuyerSignature1Url = () => {
    this.setState({
      buyer1SignatureUrl: null,
      unSavedChange: true,
      buyer1Signature: false,
      removeSignature1: true
    });
  };

  onEditBuyerSignature2Url = () => {
    this.setState({
      buyer2SignatureUrl: null,
      unSavedChange: true,
      buyer2Signature: false,
      removeSignature2: true
    });
  };

  onEditCsrSignatureUrl = () => {
    this.setState({
      csrSignatureUrl: null,
      unSavedChange: true,
      csrSignature: false,
      removeCsr: true
    });
  };

  onCancelBuyerSignature1Url = () => {
    this.setState({
      buyer1SignatureUrl: null
    }, () => {
      this.buyerSignature1.clear();
    });
  };

  onCancelBuyerSignature2Url = () => {
    this.setState({
      buyer2SignatureUrl: null
    }, () => {
      this.buyerSignature2.clear();
    });
  };

  onCancelCsrSignatureUrl = () => {
    this.setState({
      csrSignatureUrl: null
    }, () => {
      this.csrSignature.clear();
    });
  };

  renderEOCAfterSubmit = () => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.props.dispatch({
        type: RFSActionType.EOC_TEMPLATE_HOMEOWNER_ASYNC,
        params: {
          endpoint: this.state.rfsEndpoint.renderEocEndpoint,
          headers: {
            key: this.state.rfsEndpoint.headerKey,
            value: this.state.rfsEndpoint.securityToken
          }
        }
      });
    } else {
      this.props.dispatch({
        type: RFSActionType.GET_EOC_DETAIL_ASYNC,
        params: {
          refNo: this.state.refNo
        }
      });
    }

    this.setState({
      unSavedChange: false,
      buyer1Signature: true,
      buyer2Signature: true,
      csrSignature: true
    });
  };

  renderSignatureOrientation = () => {
    const { orientationCheckList,unSavedChange } = this.state;
    if (orientationCheckList) {
      return (
        <Row style={{ paddingTop: 30 }}>
          <Col xs={4}>
            <div style={{ textAlign: 'center' }} className='buyer-signature'>
              <span style={{ fontSize: 16, fontWeight: 700 }}>
                Buyer's Signature
              </span>
            </div>
            {this.state.buyer1Signature &&
            orientationCheckList.buyerSignature1Url ? (
                <div
                  style={{
                    top: '-6px',
                    bottom: '15px',
                    right: '10px',
                    textAlign: 'center',
                    minHeight: 150,
                    marginTop: 10
                  }}
                  className='signature-pad-buyer-orientation'
                >
                  <button
                    type='button'
                    className='close'
                    onClick={this.onEditBuyerSignature1Url}
                  >
                  &times;
                  </button>
                  <img
                    style={{
                      width: 200,
                      height: 90,
                      marginTop: 25,
                      marginLeft: 30
                    }}
                    src={orientationCheckList.buyerSignature1Url}
                  />
                </div>
              ) : (
                <div style={{ textAlign: 'center' }} className='signature-pad'>
                  <button
                    type='button'
                    className='close'
                    onClick={this.onCancelBuyerSignature1Url}
                  >
                  &times;
                  </button>
                  <SignatureCanvas
                    penColor='black'
                    canvasProps={{
                      top: '-6px',
                      bottom: '15px',
                      right: '10px',
                      marginLeft: 120,
                      margintop: 20,
                      width: 300,
                      maxwidth: 350,
                      height: 150
                    }}
                    className='buyerSignature1'
                    ref={ref => {
                      this.buyerSignature1 = ref;
                    }}
                    onEnd={this.onSaveBuyerSignature1}
                  />
                </div>
              )}

            <div className='buyer-signature'>
              <Row className='eoc-signature-date'>
                <div
                  style={{ textAlign: 'right', marginTop: 8, left: 25 }}
                  className='col-md-3 col-lg-3 col-xs-3'
                >
                  <span style={{ fontSize: 16, fontWeight: 700 }}>Date</span>
                </div>
                <div
                  style={{ marginLeft: 25, marginTop: 10 }}
                  className='col-md-7 col-lg-7 col-xs-7'
                >
                  <Datetime
                    ref={ref => {
                      this.buyer1Date = ref;
                    }}
                    inputProps={{ placeholder: 'MM/DD/YYYY'}}
                    timeFormat={false}
                    dateFormat='MM/DD/YYYY'
                    className='date-time-eoc-list'
                    value={this.state.buyer1Date || orientationCheckList.buyer1SignedDate && Moment(orientationCheckList.buyer1SignedDate).format('MM/DD/YYYY')}
                    onChange={buyer1Date => this.onChangeDate('buyer1Date', buyer1Date)}
                    closeOnSelect={true}
                    />
                  {this.state.error.buyer1Date &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.error.buyer1Date}</span>
                  }
                </div>
              </Row>
            </div>
          </Col>
          <Col xs={4}>
            <div style={{ textAlign: 'center' }} className='buyer-signature'>
              <span style={{ fontSize: 16, fontWeight: 700 }}>
                Buyer's Signature
              </span>
            </div>
            {this.state.buyer2Signature &&
            orientationCheckList.buyerSignature2Url ? (
                <div
                  style={{
                    top: '-6px',
                    bottom: '15px',
                    right: '10px',
                    textAlign: 'center',
                    minHeight: 150,
                    marginTop: 10
                  }}
                  className='signature-pad-buyer-orientation'
                >
                  <button
                    type='button'
                    className='close'
                    onClick={this.onEditBuyerSignature2Url}
                  >
                  &times;
                  </button>
                  <img
                    style={{
                      width: 200,
                      height: 90,
                      marginTop: 25,
                      marginLeft: 30
                    }}
                    src={orientationCheckList.buyerSignature2Url}
                  />
                </div>
              ) : (
                <div style={{ textAlign: 'center' }} className='signature-pad'>
                  <button
                    type='button'
                    className='close'
                    onClick={this.onCancelBuyerSignature2Url}
                  >
                  &times;
                  </button>
                  <SignatureCanvas
                    penColor='black'
                    canvasProps={{
                      top: '-6px',
                      bottom: '15px',
                      right: '10px',
                      marginLeft: 120,
                      margintop: 20,
                      width: 300,
                      maxwidth: 350,
                      height: 150
                    }}
                    className='buyerSignature2'
                    ref={ref => {
                      this.buyerSignature2 = ref;
                    }}
                    onEnd={this.onSaveBuyerSignature2}
                  />
                </div>
              )}
            <div className='buyer-signature'>
              <Row className='eoc-signature-date'>
                <div
                  style={{ textAlign: 'right', marginTop: 8, left: 25 }}
                  className='col-md-3 col-lg-3 col-xs-3'
                >
                  <span style={{ fontSize: 16, fontWeight: 700 }}>Date</span>
                </div>
                <div
                  style={{ marginLeft: 25, marginTop: 10 }}
                  className='col-md-7 col-lg-7 col-xs-7'
                >
                  <Datetime
                    ref={ref => {
                      this.buyer2Date = ref;
                    }}
                    inputProps={{ placeholder: 'MM/DD/YYYY'}}
                    timeFormat={false}
                    className='date-time-eoc-list'
                    value={this.state.buyer2Date || orientationCheckList.buyer2SignedDate && Moment(orientationCheckList.buyer2SignedDate).format('MM/DD/YYYY')}
                    onChange={buyer2Date => this.onChangeDate('buyer2Date', buyer2Date)}
                    closeOnSelect={true}  />
                  {this.state.error.buyer2Date &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.error.buyer2Date}</span>
                  }
                </div>
              </Row>
            </div>
          </Col>
          <Col xs={4}>
            <div style={{ textAlign: 'center' }} className='buyer-signature'>
              <span style={{ fontSize: 16, fontWeight: 700 }}>
                CSR Signature
              </span>
            </div>
            {this.state.csrSignature && orientationCheckList.csrSignatureUrl ? (
              <div
                style={{
                  top: '-6px',
                  bottom: '15px',
                  right: '10px',
                  textAlign: 'center',
                  minHeight: 150,
                  marginTop: 10
                }}
                className='signature-pad-buyer-orientation'
              >
                <button
                  type='button'
                  className='close'
                  onClick={this.onEditCsrSignatureUrl}
                >
                  &times;
                </button>
                <img
                  style={{
                    width: 200,
                    height: 90,
                    marginTop: 25,
                    marginLeft: 30
                  }}
                  src={orientationCheckList.csrSignatureUrl}
                />
              </div>
            ) : (
              <div style={{ textAlign: 'center' }} className='signature-pad'>
                <button
                  type='button'
                  className='close'
                  onClick={this.onCancelCsrSignatureUrl}
                >
                  &times;
                </button>
                <SignatureCanvas
                  penColor='black'
                  canvasProps={{
                    top: '-6px',
                    bottom: '15px',
                    right: '10px',
                    marginLeft: 120,
                    margintop: 20,
                    width: 300,
                    maxwidth: 350,
                    height: 150
                  }}
                  className='csrSignature'
                  ref={ref => {
                    this.csrSignature = ref;
                  }}
                  onEnd={this.onSaveCsrSignature}
                />
              </div>
            )}
            <div className='buyer-signature'>
              <Row className='eoc-signature-date'>
                <div
                  style={{ textAlign: 'right', marginTop: 8, left: 25 }}
                  className='col-md-3 col-lg-3 col-xs-3'
                >
                  <span style={{ fontSize: 16, fontWeight: 700 }}>Date</span>
                </div>
                <div
                  style={{ marginLeft: 25, marginTop: 10 }}
                  className='col-md-7 col-lg-7 col-xs-7'
                >
                  <Datetime
                    ref={ref => {
                      this.csrDate = ref;
                    }}
                    inputProps={{ placeholder: 'MM/DD/YYYY'}}
                    timeFormat={false}
                    className='date-time-eoc-list'
                    value={this.state.csrDate ||orientationCheckList.csrSignedDate && Moment(orientationCheckList.csrSignedDate).format('MM/DD/YYYY')}
                    onChange={csrDate => this.onChangeDate('csrDate', csrDate)}
                    closeOnSelect={true}/>
                  {this.state.error.csrDate &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.error.csrDate}</span>
                  }
                </div>
              </Row>
            </div>
          </Col>
        </Row>
      );
    }
    return null;
  };

  renderOrientationItemsRequired = () => {
    const { orientationCheckList } = this.state;

    if (orientationCheckList) {
      return (
        <div>
          {orientationCheckList.sections
            .filter(x => x.requestSectionItems === true)
            .sort((a, b) => a.order - b.order)
            .map((section, index) => {
              return (
                <div key={section.id} className='orientation-section'>
                  <div className='top-section row'>
                    <div className=' section-items row'>
                      <div
                        style={{ top: '5px' }}
                        className='col-md-12 col-lg-12 col-xs-12'
                      >
                        <div className='orientation-section-name'>
                          <h5 style={{ color: 'white', fontWeight: 'bolder' }}>
                            {section.title}
                          </h5>
                        </div>
                      </div>
                      {/* <div
                        style={{ marginLeft: '6vw', top: '5px' }}
                        className='col-md-2 col-lg-2 col-xs-2'
                      >
                        <div
                          style={{ textAlign: 'center' }}
                          className='orientation-section-name'
                        >
                          <h5>Buyer initial</h5>
                        </div>
                      </div> */}
                    </div>

                    {this.renderItemsRequired(section, index)}
                  </div>
                </div>
              );
            })}
        </div>
      );
    }

    return null;
  };

  renderItemsRequired = section => {
    if (section.checkLists.length === 0) {
      return (
        <div
          style={{ minHeight: 65 }}
          className='bottom-section'
        >
          <div className=' row item-bottom-section'>
            <div
              style={{ marginRight: 12, top: 0, left: 0 }}
              className='col-lg-1 col-md-1 col-xs-1'
            >
              <span>(empty)</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        {section.checkLists
          .sort((a, b) => a.order - b.order)
          .map(item => {
            return (
              <div
                style={{ minHeight: 65 }}
                key={item.id}
                className='bottom-section'
              >
                <div className=' row item-bottom-section'>
                  <div
                    style={{ marginRight: 12, top: 0, left: 0 }}
                    className='col-lg-2 col-md-2 col-xs-2'
                  >
                    <span>#{item.refNo}</span>
                  </div>
                  <div
                    style={{
                      // height: 25,
                      // borderRight: '1px solid lightgray',
                      top: 0,
                      right: 50
                    }}
                    className='col-md-7 col-lg-7 col-xs-7'
                  >
                    <span>{item.content}</span>
                  </div>
                  <div
                    style={{ height: 25, top: 0, right: 50 }}
                    className='col-md-2 col-lg-2 col-xs-2'
                  >
                      <span>
                       {AppSettings.WO_STATUS_VALUE.find(x => x.key === item.workOrderStatus).value}
                      </span>
                    {/* <span>{item.workOrderStatus}</span> */}
                  </div>
                  {/* {!isEmpty(item.signatureUrl) ? <div
                    style={{
                      top: '-6px',
                      bottom: '15px',
                      right: '25px',
                      textAlign: 'center',
                      minHeight: 55
                    }}
                    className='col-md-3 col-xs-3 col-lg-3'
                  >
                    <img style={{width: 200, height: 45}} src={item.signatureUrl}/>
                  </div>
                    : <div style={{right: 25, bottom: 5}} className ='col-md-3 col-xs-3 col-lg-3 signature-pad'>
                      <button type='button' className='close' onClick={this.onCancelCheckListSignatureUrl.bind(this, item)}>&times;</button>
                      <div className='signature-check-lists'>
                        <SignatureCanvas
                          clearOnResize='false'
                          minWidth={0.5}
                          maxWidth={2}
                          penColor='black'
                          canvasProps={{
                            width: 300,
                            height: 45
                          }}
                          className='signature-check-list'
                          ref={(ref) => { this[`signature ${item.order}`] = ref; }}
                          onEnd={this.onSaveCheckListSignatureUrl.bind(this, item)}
                        />
                      </div>
                    </div>} */}
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  renderOrientationSectionsItems = section => {
    if (section.checkLists.length === 0) {
      return '';
    }

    return (
      <div>
        {section.checkLists
          .sort((a, b) => a.order - b.order)
          .map(item => {
            return (
              <div key={item.id} className='bottom-section'>
                <Row
                  style={{ height: 50 }}
                  className='item-bottom-section'
                >
                  <div
                    style={{ marginRight: 12, top: 0, left: 0 }}
                    className='col-lg-2 col-md-2 col-xs-2'
                  >
                    <span>{item.order}. </span>
                  </div>
                  <div
                    style={{ height: 25, top: 0, right: 50 }}
                    className='col-md-7 col-lg-7 col-xs-7'
                  >
                    <span>{item.content}</span>
                  </div>
                  {/* <div
                    style={{ height: 25, top: 0, right: 50 }}
                    className='col-md-2 col-lg-2 col-xs-2'
                  >
                      <span>
                       {AppSettings.WO_STATUS_VALUE.find(x => x.key === item.workOrderStatus).value}
                      </span>
                  </div> */}
                  <div
                    style={{
                      top: -15,
                      float: 'right',
                      textAlign: 'center'
                    }}
                    className='col-md-1 col-xs-1 col-lg-1'
                  >
                    <CheckBoxSingle
                      name='checkbox'
                      ref={c => {
                        this.checkBox = c;
                      }}
                      style={{ display: 'inline-block' }}
                      checked={this.state.checkboxes[item.id].checked}
                      value={item.id}
                      onChecked={this.onChecked}
                    />
                  </div>
                </Row>
              </div>
            );
          })}
      </div>
    );
  };

  renderOrientationSections = () => {
    const { orientationCheckList } = this.state;

    if (orientationCheckList) {
      return (
        <div>
          {orientationCheckList.sections
            .filter(x => x.requestSectionItems === false)
            .sort((a, b) => a.order - b.order)
            .map((section, index) => {
              return (
                section.type === 0 &&
                <div key={section.id} className='orientation-section'>
                  <div className='top-section row'>
                    <div className=' section-items row'>
                      <div
                        style={{ top: '5px' }}
                        className='col-md-12 col-lg-12 col-xs-12'
                      >
                        <div className='orientation-section-name'>
                          <h5 style={{ color: 'white', fontWeight: 'bolder' }}>
                            {section.title}
                          </h5>
                        </div>
                      </div>
                    </div>

                    {this.renderOrientationSectionsItems(section, index)}
                  </div>
                </div>
              
              );
            })}
        </div>
      );
    }
    return null;
  };

  renderOrientationInformation = () => {
    const { orientationCheckList, commonInformation } = this.state;
    if (commonInformation) {
      return (
        <React.Fragment>
          <div className='eoc-table-list'>
            <Table borderless='true' style={{border: '1px solid lightgray'}}>
              <thead>
                <tr>
                  <th style={{ borderRight: '1px solid lightgray', width: '50%' }}>
                    <Row className='orientation-date' >
                      <Col style={{left: 15}} xs={5}>
                        <h5 style={{ fontWeight: 600 }}>Orientation Date </h5>
                      </Col>
                      <Col xs={7}>
                        <h5>
                          {orientationCheckList.orientationDate !== null ? Moment(orientationCheckList.orientationDate).format(
                            'MM/DD/YYYY ') : ''
                          }
                        </h5>
                      </Col>
                    </Row></th>
                  <th>
                    <Row className='orientation-coe'>
                      <Col style={{left: 15}} xs={5}>
                        <h5 style={{ fontWeight: 600 }}>
                      Estimated Close of Escrow{' '}
                        </h5>
                      </Col>
                      <Col xs={7}>
                        <h5>{commonInformation.lot.coe !== null ? Moment(commonInformation.lot.coe).format('MM/DD/YYYY') : ''}</h5>
                      </Col>
                    </Row>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ borderRight: '1px solid lightgray' }}>
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>{AppSettings.clientTypeValue === 'Homeowner' ? 'Homeowner\'s name' : 'Buyer\'s name'}</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.homeowner !== null ? <span>{commonInformation.homeowner.fullName}</span> : <span/>}
                      </Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Phone</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.homeowner !== null ? (
                          <span>{commonInformation.homeowner.phoneNumber}</span>
                        ) : (
                          <span />
                        )}
                      </Col>
                    </Row>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid lightgray' }}>
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Street address</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.lot !== null ? (
                          <span>{commonInformation.lot.streetAddress}</span>
                        ) : (
                          <span />
                        )}
                      </Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Daytime phone</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.homeowner !== null ? (
                          <span>
                            {commonInformation.homeowner.daytimePhoneNumber}
                          </span>
                        ) : (
                          <span />
                        )}
                      </Col>
                    </Row>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid lightgray' }} >
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Project</span>
                      </Col>
                      <Col xs={7}>
                        <span>{commonInformation.project.name}</span>
                      </Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Email</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.homeowner !== null ? <span>{commonInformation.homeowner.email}</span> : <span/>}
                      </Col>
                    </Row>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid lightgray' }} >
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Lot #</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.lot !== null ? (
                          <span>{commonInformation.lot.name}</span>
                        ) : (
                          <span />
                        )}
                      </Col>
                    </Row>
                  </td>
                  <td />
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid lightgray' }} >
                    <Row>
                      <Col style={{left: 15}} xs={5}>
                        <span style={{ fontWeight: 600 }}>Plan #</span>
                      </Col>
                      <Col xs={7}>
                        {commonInformation.lot !== null ? (
                          <span>{commonInformation.lot.modelName}</span>
                        ) : (
                          <span />
                        )}
                      </Col>
                    </Row>
                  </td>
                  <td />
                </tr>
              </tbody>
            </Table>
          </div>
        </React.Fragment>
      );
    }
    return null;
  };

  render() {
    const disabled = this.disabledSendEmail();
    const { commonInformation, orientationCheckList } = this.state;
    if (commonInformation) {
      return (
        <React.Fragment>
          <div className='rfs-detail'>
            <div className='page-title clearfix'>
              <h2 className='pull-left'>Electronic Signature Form</h2>
              <div style={{ marginTop: 15 }} className='text-right print-icon'>
                {AppSettings.clientTypeValue === 'Builder' ? <i
                  onClick={this.state.unSavedChange ? this.onPrintEOCTemplateAndSaveEOC : this.onPrintEOCTemplate}
                  className='glyphicon glyphicon-print'
                /> : null}
              </div>
              {AppSettings.clientTypeValue === 'Builder' ? <ul className='breadcrumb'>
                <li>
                  <Link to={'/request-for-services'}>Requests for service</Link>
                </li>
                <li className='breadcrumb-siteone-li'>
                  <Link to={`/request-for-services/${this.state.refNo}`}>
                    RFS #{this.state.refNo}
                  </Link>
                </li>
                <li className='breadcrumb-siteone-li'>ESF</li>
              </ul> : <ul style={{marginTop: 50}} className='breadcrumb'>
                <li className='breadcrumb-siteone-li'>
                  <Link to={`/request-for-services/${this.state.refNo}`}>
                    RFS #{this.state.refNo}
                  </Link>
                </li>
                <li className='breadcrumb-siteone-li'>ESF</li>
              </ul>}
            </div>
            <div
              style={{ padding: 30, paddingTop: 10 }}
              className='wrapper box-form-siteone'
            >
              <Row className='clearfix'>
                <h3 style={{ fontSize: 34, marginLeft: 10 }}>
                Electronic Signature Form
                </h3>
              </Row>
              <Row className='clearfix'>
                <Col xs={6}>
                  <Row>
                    <Col xs={3}>
                      <h5 style={{fontWeight: 600, color: '#9a9caa'}}>Type</h5>
                    </Col>
                    <Col xs={9}>
                      <h5>{orientationCheckList.templateName}</h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className='builderInformation'>
                <Row>
                  <Col xs={6}>
                    <Row>
                      <Col style={{marginBottom: 5, marginTop: 20}} xs={3}>
                        <span>{commonInformation.clientName}</span>
                      </Col>
                      <Col style={{marginBottom: 5, marginTop: 20}} xs={8}>
                        <span style={{wordBreak: 'break-word'}}>{commonInformation.streetAddress}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3}>
                        <span>{commonInformation.clientPhone}</span>
                      </Col>
                      <Col xs={8}>
                        <span>{commonInformation.clientEmail}</span>
                      </Col>
                    </Row>
                  </Col>

                  <Col className='builder-logo' style={{textAlign: 'center', height: 75}} xs={6}>
                    <img
                      className='logo'
                      style={{ maxHeight: 75 }}
                      src={commonInformation.logoUrl}
                    />
                  </Col>
                </Row>
              </div>
              {/* <Row style={{ marginRight: 7 }} className='builder-information'>
                <Col xs={6} className='builder-information'>
                  <Row>
                    <Col xs={3} className='builder-information'>
                      <div
                        style={{ marginBottom: 15 }}
                        className='builder-name'
                      >

                      </div>
                      <div className='builder-client'>
                      </div>
                    </Col>
                    <Col xs={8} className='builder-information'>
                      <div className='builder-address'>

                      </div>
                      <div
                        className='builder-email'
                        style={{ marginTop: 15 }}
                      >
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col
                  style={{ textAlign: 'center', height: 75 }}
                  xs={6}
                  className='builder-logo'
                >
                  <img
                    className='logo'
                    style={{ maxHeight: 75 }}
                    src={commonInformation.logoUrl}
                  />
                </Col>
              </Row> */}
              {this.renderOrientationInformation()}

              {this.renderOrientationSections()}

              {this.renderOrientationItemsRequired()}
              {orientationCheckList.disclaimerText !== null ? <div style={{marginLeft: 0, whiteSpace: 'pre-line'}} className='row disclaimer-text'>
                {orientationCheckList.disclaimerText}
              </div> : null}
              {this.renderSignatureOrientation()}

              <div
                className='modal-footer'
                style={{ float: 'left', marginTop: 30, borderTop: 'none', width: 800}}
              >
                {AppSettings.clientTypeValue === 'Builder' ? <Row>
                  <Col style={{borderRight: '1px solid lightgray', textAlign: 'left', width: 225}} xs={4}>
                    <button
                      style={{ marginRight: 10 }}
                      onClick={this.onCancel}
                      className='btn btn-primary btn-siteone-default'
                    >
                  Cancel
                    </button>
                    <button
                      onClick={this.onSubmit}
                      className='btn btn-primary btn-siteone'
                    >
                  Save
                    </button>
                  </Col>
                  <Col style={{marginLeft: 12}} xs={6}>
                    <div className='button-function-eoc'>
                      <button
                        style={{marginRight: 10}}
                        onClick={this.onSaveLotDocument}
                        className='btn btn-primary btn-siteone-orange'
                      >
                  Save to lot documents
                      </button>
                      <button
                        onClick={this.onSendEmailPrimaryOwner}
                        className='btn btn-primary btn-siteone-orange'
                      >
                  Email...
                      </button>
                    </div>
                  </Col>
                </Row> : <Row><Col xs={4}><button
                  style={{ marginRight: 10 }}
                  onClick={this.onCancel}
                  className='btn btn-primary btn-siteone-default'
                >
                  Cancel
                </button>
                <button
                  onClick={this.onSubmit}
                  className='btn btn-primary btn-siteone'
                >
                  Save
                </button></Col></Row>}
              </div>
            </div>

            {this.state.isDisplayEmailPopUp &&
            <Popup
              ref={ref => {
                this.sendEmailPopup = ref;
              }}
              className='reopen-popup'
              isHasFaded={true}
              styles={popupStyle}
            >
              <div className='recipients-email-eoc container-fluid'>
                <label>
                      Recipients{' '}
                  <span className='text-danger'>*</span>
                </label>
                <button
                  type='button'
                  className='close'
                  onClick={this.onCloseEmailPopup}
                >
                  &times;
                </button>
                <TagsInput
                  value={this.state.recipientEmail}
                  onChange={tags => {
                    this.handleChange(tags, 0);
                  }}
                  inputProps={this.state.inputProps}
                  addKeys={TAGS_LIST}
                  addOnBlur
                  autoFocus
                  onlyUnique={true}
                  suggestions={this.state.suggestions}
                  autocomplete={true}
                />
                <button disabled={disabled} onClick={this.onSendEOCEmail} style={{float: 'left', marginTop: 7}} className='btn btn-primary btn-siteone'>Send</button>
              </div>
            </Popup>}

            { this.state.openConfirmSavePopup &&
              <Popup
                ref={ref => {
                  this.saveAndProcess = ref;
                }}
                className='reopen-popup'
                isHasFaded={true}
                styles={this.state.confirmSendEmailPopup ? saveAndSendEmailStyle : saveAndProcessStyle}
              >
                <div className='recipients-email-eoc container-fluid'>
                  <label>
                  Confirmation{' '}
                  </label>
                  <div style={{marginTop: 5}}>
                    <span>You have unsaved changes. Do you want to save before proceeding?</span>
                  </div>
                </div>
                <div className='button-save-confirm-popup'>
                  <button
                    type='button'
                    className='btn btn-primary btn-siteone-default'
                    onClick={() => this.setState({openConfirmSavePopup: false})}
                  >
                  Cancel
                  </button>
                  <button style={{marginLeft: 10}} onClick={this.state.confirmSendEmailPopup ? this.onSaveAndSendEmail : this.onSaveAndSaveToLotDocument} className='btn btn-primary btn-siteone'>Save and Proceed</button>
                </div>
              </Popup>
            }

            <iframe
              id='ifmcontentstoprint'
              style={{ height: 0, border: 'none' }}
            />
          </div>
        </React.Fragment>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    EOCProfile: state.RFSStore.EOCProfile,
    RFSEndpoint: state.RFSStore.RFSEndpoint,
    HomeownerPrimaryEmail: state.RFSStore.HomeownerPrimaryEmail
  };
};

export default connect(mapStateToProps)(EocListItems);



// WEBPACK FOOTER //
// ./src/Request-Services/Containers/eoc-list-items.js